export enum TripDefinitionsEnum {
    DEFAULT_TRIP_DEFINITION = 'Default Trip Definition',
}
